"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DataDictionaryError_1 = require("../model/data-dictionary/DataDictionaryError");

var FlagSet_1 = require("../model/FlagSet");

var utils_1 = require("../utils");
/**
 * DataObjectConversions contains general implementation of data type conversion
 * between JSON object and domain object.
 *
 * @author JMe
 */


var DataObjectConversions =
/*#__PURE__*/
function () {
  function DataObjectConversions() {
    _classCallCheck(this, DataObjectConversions);
  }

  _createClass(DataObjectConversions, [{
    key: "asObjectOpt",

    /**
     * Converts field from JSON document (or an object) to object of type T, may return null.
     *
     * @param document the JSON document
     * @param field field to extract from document
     * @param convert conversion function between document and result type T
     * @returns converted document field as object of result type T or null
     */
    value: function asObjectOpt(document, field, convert) {
      if (!document) {
        throw new DataDictionaryError_1.DataDictionaryError('document must be set!');
      }

      if (utils_1.Utils.isValueMissing(document[field])) {
        return null;
      }

      return convert(document[field]);
    }
    /**
     * Converts field from JSON document (or an object) to object of type T
     *
     * @param document the JSON document
     * @param field field to extract from document
     * @param convert conversion function between document and result type T
     * @returns converted document field as object of result type T
     */

  }, {
    key: "asObject",
    value: function asObject(document, field, convert) {
      //const start = process.hrtime();
      var result = this.asObjectOpt(document, field, convert);

      if (result === null) {
        throw new DataDictionaryError_1.DataDictionaryError("Null object value for field ".concat(field, " in document ").concat(JSON.stringify(document), " not allowed!"));
      } //this.logTime('asObject', process.hrtime(start));


      return result;
    }
  }, {
    key: "asFlagSet",
    value: function asFlagSet(document, base) {
      //const start = process.hrtime();
      if (!utils_1.Utils.isArray(document)) {
        throw new DataDictionaryError_1.DataDictionaryError('Document must be an array');
      }

      var ret = new FlagSet_1.FlagSet(base);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = document[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var it = _step.value;
          ret.addDeserialized(it);
        } //this.logTime('asFlagSet', process.hrtime(start));

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return ret;
    }
    /**
     * Converts field from JSON document to list of object of result type T. Field of JSON
     * document must be an array of objects.
     *
     * @param document the JSON document
     * @param field field from JSON document to extract, field must be an array
     * @param convert conversion function between document and item of list of result type T
     * @returns converted field array as list of object of result type T
     */

  }, {
    key: "asObjectList",
    value: function asObjectList(document, field, convert) {
      if (!document) {
        throw new DataDictionaryError_1.DataDictionaryError('document must be set!');
      }

      if (!document[field]) {
        return immutable_1.List();
      }

      if (!Array.isArray(document[field])) {
        throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be an array! Found: ").concat(typeof document[field]));
      }

      var items = document[field];
      return immutable_1.List(items.map(function (item) {
        return convert(item);
      }));
    }
    /**
     * Converts field from JSON document to set of object of result type T. Field of JSON
     * document must be an array of objects.
     *
     * @param document the JSON document
     * @param field field from JSON document to extract, field must be an array
     * @param convert conversion function between document and item of list of result type T
     * @returns converted field array as set of object of result type T
     */

  }, {
    key: "asObjectSet",
    value: function asObjectSet(document, field, convert) {
      if (!document) {
        throw new DataDictionaryError_1.DataDictionaryError('document must be set!');
      }

      if (!document[field]) {
        return immutable_1.Set();
      }

      if (!Array.isArray(document[field])) {
        throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be an array! Found: ").concat(typeof document[field]));
      }

      var items = document[field];
      return immutable_1.Set(items.map(function (item) {
        return convert(item);
      }));
    }
    /**
     * Converts field representing list of result type T from JSON document to
     * an array of objects.
     *
     * @param object the object
     * @param field field from object to extract, field must be a list
     * @param convert conversion function from result type T to JSON object
     */

  }, {
    key: "asObjectArray",
    value: function asObjectArray(object, field, convert) {
      if (!object) {
        throw new DataDictionaryError_1.DataDictionaryError('object must be set!');
      }

      if (!object[field]) {
        return [];
      }

      if (!(object[field] instanceof immutable_1.List) && !(object[field] instanceof immutable_1.Set)) {
        throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be a list or a set!"));
      }

      var items = object[field];
      return items.filter(function (item) {
        return item !== undefined && item !== null;
      }).map(function (item) {
        return convert(item);
      }).toArray();
    }
    /**
     * Converts the given string or number literal to an enum value of the given enum type, may return null.
     *
     * @param value the string or number literal of enum
     * @param enumObject the enumeration type itself
     * @returns converted enum value
     */

  }, {
    key: "asEnumOpt",
    value: function asEnumOpt(value, enumObject) {
      if (!value) {
        return null;
      }

      var key = Object.keys(enumObject).find(function (enumKey) {
        return enumObject[enumKey] === value;
      });

      if (!key) {
        return null;
      }

      return enumObject[key];
    }
    /**
     * Converts the given string or number literal to an enum value of the given enum type.
     *
     * @param value the string or number literal of enum
     * @param enumObject the enumeration type itself
     * @returns converted enum value
     */

  }, {
    key: "asEnum",
    value: function asEnum(value, enumObject) {
      //const start = process.hrtime();
      var result = this.asEnumOpt(value, enumObject);

      if (!result) {
        throw new DataDictionaryError_1.DataDictionaryError("Enum ".concat(JSON.stringify(enumObject).substr(0, 80), " does not have value for input ").concat(value));
      } //Profiling.logTime('asEnum', process.hrtime(start));


      return result;
    }
    /**
     * <p>
     * Converts field from JSON document to list of class reference ids. Field of JSON
     * document must be an array of objects. Validates whether every value is filled.
     * </p>
     *
     * @param document the JSON document
     * @param field field from JSON document to extract, field must be an array
     * @returns converted field array as list of class reference ids
     * @throws error if some source value is missing.
     */

  }, {
    key: "asClassReferenceIdsList",
    value: function asClassReferenceIdsList(document, field) {
      var _this = this;

      return this.asObjectList(document, field, function (value) {
        if (utils_1.Utils.isValueMissing(value)) {
          throw new DataDictionaryError_1.DataDictionaryError("Some field ('".concat(field, "') value representing reference id is missing!"));
        }

        return _this.toClassReferenceId(value);
      });
    }
    /**
     * <p>
     * Converts field from JSON document to set of class reference ids. Field of JSON
     * document must be an array of objects. Validates whether every value is filled.
     * </p>
     *
     * @param document the JSON document
     * @param field field from JSON document to extract, field must be an array
     * @returns converted field array as set of class reference ids
     * @throws error if some source value is missing.
     */

  }, {
    key: "asClassReferenceIdsSet",
    value: function asClassReferenceIdsSet(document, field) {
      return this.asClassReferenceIdsList(document, field).toSet();
    }
    /**
     * Converts field representing map with values of type T and keys of type K to array of key - value pairs.
     *
     * @param object the object
     * @param field field from object to extract, field must be a map
     * @param convertKey conversion function from key type K to JSON object
     * @param convertValue conversion function from value type T to JSON object
     */

  }, {
    key: "asKeyValuePairs",
    value: function asKeyValuePairs(object, field, convertKey, convertValue) {
      if (!object) {
        throw new DataDictionaryError_1.DataDictionaryError('object must be set!');
      }

      if (!object[field]) {
        return [];
      }

      if (!(object[field] instanceof immutable_1.Map)) {
        throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be a map!"));
      }

      var map = object[field];
      return map.filter(function (value, key) {
        return key !== undefined && key !== null && value !== undefined && value !== null;
      }).mapEntries(function (entry) {
        return [convertKey(entry[0]), convertValue(entry[1])];
      }).toArray();
    }
    /**
     * Converts field from JSON document to map of objects of key type K and value type T. Field of JSON
     * document must be an array of key - value pairs.
     *
     * @param document the JSON document
     * @param field field from JSON document to extract, field must be an array of key - value tuples
     * @param convertKey conversion function between document and map key of type K
     * @param convertValue conversion function between document and map value of type T
     * @returns converted field array as map with keys of type K and values od type T
     */

  }, {
    key: "asMap",
    value: function asMap(document, field, convertKey, convertValue) {
      if (!document) {
        throw new DataDictionaryError_1.DataDictionaryError('document must be set!');
      }

      if (!document[field]) {
        return immutable_1.Map();
      }

      if (!Array.isArray(document[field])) {
        throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be an array!"));
      }

      var entries = document[field];
      var convertedEntries = entries.map(function (entry) {
        if (!utils_1.Utils.isArray(entry)) {
          throw new DataDictionaryError_1.DataDictionaryError("field ".concat(field, " must be an array of arrays/tuples!"));
        }

        if (entry.length !== 2) {
          throw new DataDictionaryError_1.DataDictionaryError("items of field ".concat(field, " must be an array of exactly two items (key - value pairs)!"));
        }

        return [convertKey(entry[0]), convertValue(entry[1])];
      });
      return immutable_1.Map(convertedEntries);
    }
  }]);

  return DataObjectConversions;
}();

exports.DataObjectConversions = DataObjectConversions;